import { render, staticRenderFns } from "./estate-specifications-section.vue?vue&type=template&id=0b210c8d&"
import script from "./estate-specifications-section.vue?vue&type=script&lang=js&"
export * from "./estate-specifications-section.vue?vue&type=script&lang=js&"
import style0 from "./estate-specifications-section.vue?vue&type=style&index=0&id=0b210c8d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports